module.exports = __webpack_public_path__ + "img/omlette.113e16ad.png";